import { render, staticRenderFns } from "./TemplatePath.vue?vue&type=template&id=c09b2e12"
import script from "./TemplatePath.vue?vue&type=script&lang=js"
export * from "./TemplatePath.vue?vue&type=script&lang=js"
import style0 from "./TemplatePath.vue?vue&type=style&index=0&id=c09b2e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports